module.exports = __webpack_public_path__ + "static/infernal-rapture-menu-b2b15ac263a2058c772ff761d7fb29bc.png";